export const SET_TRENDS_SUCCESS = 'SET_TRENDS_SUCCESS';
export const SET_TRENDS_REQUEST = 'SET_TRENDS_REQUEST';
export const SET_TRENDS_FAILED = 'SET_TRENDS_FAILED';
export const SET_TRENDS_TRENDS_LIST_SUCCESS = 'SET_TRENDS_TRENDS_LIST_SUCCESS';
export const SET_TRENDS_INFLUENCE_LIST_SUCCESS = 'SET_TRENDS_INFLUENCE_LIST_SUCCESS';
export const SET_TRENDS_LINK_SUCCESS = 'SET_TRENDS_LINK_SUCCESS';
export const CLEAN_TRENDS = 'CLEAN_TRENDS';
